module.exports = __webpack_public_path__ + "img/rip.0c5a626f.png";